// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":export {\n  larguraMenuPontotel: 64px;\n  alturaMenuPontotelMobile: 66px;\n  larguraColunaAssistente: 380px;\n  respiroAssistente: 12px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
